import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ImageService } from 'src/app/services/image.service';

@Component({
  selector: 'app-image-geo-info',
  templateUrl: './image-geo-info.component.html',
  styleUrls: ['./image-geo-info.component.scss']
})
export class ImageGeoInfoComponent implements OnChanges {
  @Input() image: any;

  @Output() mapClicked = new EventEmitter<void>();

  constructor(private imageService: ImageService) { }

  ngOnChanges(): void {
    this.getImageAddress();
  }

  getImageAddress() {
    const image = this.image;
    if (!image?.latitude || !image?.longitude || image.physicalAddress) return;

    this.imageService.getAddress({ latitude: image.latitude, longitude: image.longitude }).subscribe((data) => {
      if (data.body?.status === 'OK') {
        image.physicalAddress = data.body.data;
      }
    });
  }
}
